import React from 'react';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import { Row, REFACTOR_DATE } from '../../Resources';
import ActivitiesRegistrationHeader from '../../ActivitiesRegistrationHeader';

import { convertToReal } from 'helpers/converters';

export default function TransactionRemotion({ lastRegister, activityData }) {
  if(moment(activityData?.updatedAt, 'YYYY-MM-DD HH:mm:ss').isBefore(REFACTOR_DATE)) {
    return(
      <Grid container>
        <Grid xs={12}>
          <ActivitiesRegistrationHeader activityData={activityData} />
        </Grid>
        <Grid container style={{ marginTop: 10 }}>
          <Grid xs={12}>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              <Row>
                <Typography color='primary'>
                  <b>Descrição</b>
                </Typography>
                <Typography color='textSecondary'>
                  {lastRegister?.transaction?.description || '--'}
                </Typography>
              </Row>
              <Row>
                <Typography color='primary'>
                  <b>Categoria</b>
                </Typography>
                <Typography color='textSecondary'>
                  {lastRegister?.transaction?.categoryName || '--'}
                </Typography>
              </Row>
              <Row>
                <Typography color='primary'>
                  <b>Data do pagamento</b>
                </Typography>
                <Typography color='textSecondary'>
                  {moment(lastRegister?.transaction?.paymentDateTime).format('DD/MM/YYYY HH:mm:ss')}
                </Typography>
              </Row>
              <Row>
                <Typography color='primary'>
                  <b>Valor</b>
                </Typography>
                <Typography color='textSecondary'>
                  {convertToReal(lastRegister?.transaction?.amount)}
                </Typography>
              </Row>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader activityData={activityData} />
      </Grid>
      <Grid container style={{ marginTop: 10 }}>
        <Grid xs={12}>
          <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
            {Object.keys(lastRegister).includes('description') && (
              <Row>
                <Typography color='primary'>
                  <b>Descrição</b>
                </Typography>
                <Typography color='textSecondary'>
                  {lastRegister?.description || '--'}
                </Typography>
              </Row>
            )}
            {Object.keys(lastRegister).includes('categoryName') && (
              <Row>
                <Typography color='primary'>
                  <b>Categoria</b>
                </Typography>
                <Typography color='textSecondary'>
                  {lastRegister?.categoryName || '--'}
                </Typography>
              </Row>
            )}
            {Object.keys(lastRegister).includes('paymentDateTime') && (
              <Row>
                <Typography color='primary'>
                  <b>Data do pagamento</b>
                </Typography>
                <Typography color='textSecondary'>
                  {moment(lastRegister?.paymentDateTime).format('DD/MM/YYYY HH:mm:ss')}
                </Typography>
              </Row>
            )}
            {Object.keys(lastRegister).includes('amount') && (
              <Row>
                <Typography color='primary'>
                  <b>Valor</b>
                </Typography>
                <Typography color='textSecondary'>
                  {convertToReal(lastRegister?.amount)}
                </Typography>
              </Row>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}